module.exports = __webpack_public_path__ + "img/arrow_down.f5840f48.svg";